import { useNavigate } from "react-router-dom";
import { Survey } from "@/types";
import { useTranslations } from "@/contexts/Translation";
import { useProfile } from "@/contexts/UserProvider";
import CreateLink from "../CreateLink/CreateLink";
import { InfoMessage } from "../InfoMessage/InfoMessage";
import Link from "../Link/Link";
import { CategoryScores } from "./insights";
import SurveyRow from "./SurveyRow";
import styles from "./Index.module.css";

// The surveys the dashboard shows: every ongoing one and the latest finished one.
export const dashboardSurveys = (surveys: Survey[]) => [
  ...surveys.filter((s) => s.status === "ongoing"),
  ...surveys.filter((s) => s.status === "finished").slice(0, 1),
];

const SurveyList = ({ surveys, scoresById }: { surveys: Survey[]; scoresById: Record<string, CategoryScores> }) => {
  const t = useTranslations("surveys");
  const navigate = useNavigate();
  const profile = useProfile();

  const createSurvey = () => {
    navigate(`/survey`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section aria-labelledby='surveys-heading'>
      <div className={styles.listHeading}>
        <h2 id='surveys-heading' className={styles.panelTitle}>
          {t("title")}
        </h2>
        <Link href='/surveys'>{t("dashboard.seeAllSurveys")}</Link>
      </div>
      {surveys.length === 0 && <InfoMessage>{t("noSurveys")}</InfoMessage>}
      <div className={styles.rows}>
        {dashboardSurveys(surveys).map((s) => (
          <SurveyRow key={s.id} survey={s} scores={scoresById[s.id]} />
        ))}
      </div>
      {!profile?.hasValidSubscription && surveys.length > 0 ? (
        <InfoMessage>{t("onlyOneSurvey")}</InfoMessage>
      ) : (
        <CreateLink createFn={createSurvey} text={t("createSurvey")} />
      )}
    </section>
  );
};

export default SurveyList;
